import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, BackdropCircular, ImageGalleryDialog} from 'components';
import {
  Card,
  Typography,
  Divider,
  Grid,
  Switch,
  TextField,
  Button,
  Icon
} from '@material-ui/core';
import {
  getHomepageRewardBlockConfigsApi,
  saveHomepageRewardBlockConfigsApi,
  getAssetManagerTagByCodeApi
} from 'api';
import {
  changeHomepageRewardBlockConfigConfig
} from 'redux/actions/store_configs';
import { assetManagerUrl } from 'configs';
import RewardBlockPreview from './RewardBlockPreview';


const REWARD_TAG_CODE = 'block_reward_points_desktop';

const RewardBlock = () => {
  const dispatch = useDispatch();
  const [openImageDialog, toggleOpenImageDialog] = useState(false);
  const [rewardTagId, setRewardTagId] = useState<number | null>(null);

  const {
    homepageRewardBlockConfigs = [],
    loadingHomepageRewardBlockConfigs,
    savingHomepageRewardBlockConfigs
  } = useSelector((state: IReduxState) => state.store_configs);

  const { loadingAssetCategoryTags } = useSelector((state: IReduxState) => state.asset_manager);

  const loading = loadingHomepageRewardBlockConfigs ||
    savingHomepageRewardBlockConfigs ||
    loadingAssetCategoryTags;

  useEffect(() => {
    if (!homepageRewardBlockConfigs.length) {
      getHomepageRewardBlockConfigsApi({dispatch});
    }

    if (rewardTagId === null) {
      getAssetManagerTagByCodeApi({ dispatch, tagCode: REWARD_TAG_CODE })
        .then((tag) => {
          if (tag?.id) {
            setRewardTagId(tag.id);
          }
        });
    }
  });

  const configValue = (path) => {
    return !homepageRewardBlockConfigs.length
      ? ''
      : homepageRewardBlockConfigs.find((config) => config.path === path).value;
  };

  const isBlockEnabled = configValue('store_info/reward_homepage/is_reward_block_enabled');
  const contentValue = configValue('store_info/reward_homepage/reward_block_content');
  const imageSrc = configValue('dermpro/design/reward_points_desktop');

  const handleChange = (event) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeHomepageRewardBlockConfigConfig(name, checked, type, value));
  };

  const handleSelectImage = (data) => {
    const value = `${assetManagerUrl}/${data?.webPath}`;
    dispatch(changeHomepageRewardBlockConfigConfig(
      'dermpro/design/reward_points_desktop',
      null,
      'text',
      value
    ));
  };

  const handleSave = () => {
    saveHomepageRewardBlockConfigsApi({dispatch, configs: homepageRewardBlockConfigs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: 'Reward Block'}
        ]}
      />
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Reward Block</Typography>
          <Divider className="mb-8" />
          <Grid container spacing={3} className="mb-8">
            <Grid item xs={12} sm={2} className="my-2 ml-4">Enable</Grid>
            <Grid item xs={12} sm={9}>
              <Switch
                color="primary"
                name={'store_info/reward_homepage/is_reward_block_enabled'}
                checked={isBlockEnabled == 1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="ml-4">Content</Grid>
            <Grid item xs={12} sm={9}>
              <TextField
                fullWidth
                multiline
                rows={7}
                variant="outlined"
                name={'store_info/reward_homepage/reward_block_content'}
                label="Text"
                value={contentValue}
                onChange={handleChange}
                inputProps={{
                  className: 'p-0',
                  shrink: true
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="ml-4">Image</Grid>
            <Grid item xs={12} sm={9}>
              <Button
                className="w-full max-w-300"
                variant="outlined"
                color="primary"
                size="large"
                onClick={() => toggleOpenImageDialog(true)}
              >
                <Icon className="mr-2">wallpaper</Icon>
                Select Image
              </Button>
            </Grid>
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="mt-10 mb-5"
            onClick={handleSave}
          >
            Save Configurations
          </Button>
        </div>
        <RewardBlockPreview
          isBlockEnabled={isBlockEnabled}
          contentValue={contentValue}
          imageSrc={imageSrc}
        />
      </div>
      <ImageGalleryDialog
        title="Select Reward Block Image"
        open={openImageDialog}
        setOpen={toggleOpenImageDialog}
        onImageSelect={handleSelectImage}
        imageTagId={rewardTagId}
        cols={4}
        rowHeight={340}
      />
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default RewardBlock;
